export const NoData = () => {
  return (
    <div className="flex w-full place-content-center content-center justify-center text-slate-500">
      No data.
    </div>
  );
};